import React from "react";
import { Carousel } from "antd";
import { HiOutlineQueueList } from "react-icons/hi2";
import { FaRegMoneyBillAlt } from "react-icons/fa";
import { AiOutlineVideoCamera } from "react-icons/ai";
import { ImFilesEmpty } from "react-icons/im";

const FeaturesCard = () => {
  const handleClick = (link) => {
    switch (link) {
      case "queue_appointments":
        window.open(
          `https://kulcare.com/practice-management/#queue_appointments`
        );
        break;
      case "records_sharing":
        window.open(`https://kulcare.com/#records_sharing`);
        break;
      case "video_consultation":
        window.open(
          `https://kulcare.com/practice-management/#video_consultation`
        );
        break;

      case "smart_billing":
        window.open(`https://kulcare.com/practice-management/#smart_billing`);
        break;

      default:
        window.open(`https://kulcare.com/`);
    }
  };
  return (
    <div className="home-card carousel-card">
      <Carousel autoplay className="feature-carousel">
        {/* carousel item start  */}
        <div
          className="feature-carousel-item"
          onClick={() => handleClick("queue_appointments")}
        >
          <div className="carousel-icon">
            <HiOutlineQueueList />
          </div>
          <div className="carousel-heading">Smart Queue</div>
          <div className="carousel-text">
            Digital front office with billing and eRx
          </div>
        </div>
        {/* carousel item end  */}
        {/* carousel item start  */}
        <div
          className="feature-carousel-item"
          onClick={() => handleClick("records_sharing")}
        >
          <div className="carousel-icon">
            <ImFilesEmpty />
          </div>
          <div className="carousel-heading">Easy Record Sharing</div>
          <div className="carousel-text">
            With just a few clicks, patients can securely uplaod and share their
            records.
          </div>
        </div>
        {/* carousel item end  */}
        {/* carousel item start  */}
        <div
          className="feature-carousel-item"
          onClick={() => handleClick("video_consultation")}
        >
          <div className="carousel-icon">
            <AiOutlineVideoCamera />
          </div>
          <div className="carousel-heading">Teleconsultations</div>
          <div className="carousel-text">
            Take qucik teleconsultations with your patients
          </div>
        </div>
        {/* carousel item end  */}
        {/* carousel item start  */}
        <div
          className="feature-carousel-item"
          onClick={() => handleClick("smart_billing")}
        >
          <div className="carousel-icon">
            <FaRegMoneyBillAlt />
          </div>
          <div className="carousel-heading">Smart Billing</div>
          <div className="carousel-text">
            State of the art billing module to handle all kinds of transactions
          </div>
        </div>
        {/* carousel item end  */}
      </Carousel>
    </div>
  );
};

export default FeaturesCard;
